import { DETERMINAR_PAGINA_ATUAL_PRECO } from '../types'

export default function determinarPaginaAtualPreco (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_PRECO,
    payload: paginaAtual
  }
}
